import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=5e7c4a6a"
import script from "./LoadingComponent.vue?vue&type=script&lang=ts"
export * from "./LoadingComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports